interface ApiError {
  data: { message: string };
}

export function isApiError(e: unknown): e is ApiError {
  if (typeof e !== "object" || e === null) return false;

  // Treat it as a generic record so TS lets us index into it
  const record = e as Record<string, unknown>;

  // Check there’s a `data` property that’s also an object
  if (typeof record.data !== "object" || record.data === null) return false;

  // Now check that `data` has a `message` string
  const dataRecord = record.data as Record<string, unknown>;
  return typeof dataRecord.message === "string";
}
